export default __webpack_public_path__ + "static/media/gmts-kun_icon_moji_ikitai_20px.8c69df0e.png";